import { z } from 'zod';

import { CustomsStateNotificationType, TSDBusinessValidationType, TSDStatus, TSDType } from '@e-origin/shared';

import { TSDInvalidationDecisionSchema } from './TSDCustomsStateSchema';

export const TSDListItemSchema = z.object({
  _id: z.any(),
  counter: z.number(),
  name: z.string(),
  customer: z.any(),
  template: z.any().optional(),
  updatedAt: z.date(),
  useCustomsSimulator: z.boolean().optional(),
  generalInfo: z.object({
    type: z.nativeEnum(TSDType),
    status: z.nativeEnum(TSDStatus),
    isDeconsolidated: z.boolean().optional(),
    isDeconsolidatedRejected: z.boolean().optional(),
    isAmended: z.boolean().optional(),
    wasAcceptedByCustoms: z.boolean().optional(),
  }),
  messageInfo: z.object({
    LRN: z.string(),
    CRN: z.string().optional(),
    MRN: z.string().optional(),
    FRN: z.string().optional(),
  }),
  customsState: z
    .object({
      notifications: z.array(
        z.object({
          notificationType: z.nativeEnum(CustomsStateNotificationType),
          message: z.string(),
          read: z.boolean(),
        }),
      ),
      customsDeclarationRejection: z
        .object({
          businessRejectionType: z.nativeEnum(TSDBusinessValidationType).optional(),
        })
        .optional(),
      invalidationDecision: TSDInvalidationDecisionSchema.nullable(),
      businessValidationType: z.string().optional(),
    })
    .optional(),
});
export type TSDListItem = z.infer<typeof TSDListItemSchema>;
